var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root"},[(_vm.isVisible)?_vm._t("default"):_vm._e(),_vm._v(" "),(!_vm.isVisible)?_vm._t("placeholder"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }